export default __webpack_public_path__ + "static/media/06.cc9697c4.jpg";